export default __webpack_public_path__ + "static/media/bellavista0floormap.5829f717.png";